// // pages/assessment/TakeAssessment.jsx
// import { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Button,
//   Paper,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormControl,
//   FormLabel,
//   CircularProgress,
//   Alert,
//   Divider,
// } from "@mui/material";
// import { useATS } from "../atsModule/context/ATSContext";

// const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// const TakeAssessment = () => {
//   const { assignmentId } = useParams();
//   const navigate = useNavigate();
//   const { store_id } = useATS();
//   const { user_id } = useATS(); // Assuming useATS provides user_id. If not, get from context/localStorage.

//   const [assignment, setAssignment] = useState(null);
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState("");
//   const [submitted, setSubmitted] = useState(false);
//   const [result, setResult] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!store_id && store_id !== 0) return;
//       try {
//         setLoading(true);
//         // Get assignment details
//         const assignmentRes = await axios.get(
//           `${API_BASE}/api/assessment/user-assessments/${assignmentId}`,
//         );
//         const assignData = assignmentRes.data.data;
//         setAssignment(assignData);
//         // Get questions for this assessment
//         const questionsRes = await axios.get(
//           `${API_BASE}/api/assessment/assessment-questions/assessment/${assignData.assessment_id}`,
//         );
//         setQuestions(questionsRes.data.data || []);
//         setError("");
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load assessment");
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (assignmentId) fetchData();
//   }, [assignmentId, store_id]);

//   const handleAnswerChange = (questionId, value) => {
//     setAnswers({ ...answers, [questionId]: parseInt(value) });
//   };

//   const handleSubmit = async () => {
//     // Check all questions answered
//     if (
//       questions.length > 0 &&
//       Object.keys(answers).length !== questions.length
//     ) {
//       alert(`Please answer all ${questions.length} questions.`);
//       return;
//     }
//     const answersArray = Object.entries(answers).map(
//       ([questionId, selected_option]) => ({
//         question_id: parseInt(questionId),
//         selected_option,
//       }),
//     );
//     setSubmitting(true);
//     try {
//       const res = await axios.post(
//         `${API_BASE}/api/assessment/user-assessments/${assignmentId}/submit-mcq`,
//         {
//           store_id,
//           user_id,
//           answers: answersArray,
//           remarks: "",
//         },
//       );
//       setResult(res.data.data);
//       setSubmitted(true);
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.statusMessage || "Submission failed");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   if (loading)
//     return <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
//   if (error) return <Alert severity="error">{error}</Alert>;
//   if (submitted && result) {
//     return (
//       <Box sx={{ textAlign: "center", mt: 4 }}>
//         <Paper sx={{ p: 4, maxWidth: 500, mx: "auto" }}>
//           <Typography variant="h5" gutterBottom>
//             Assessment Submitted!
//           </Typography>
//           <Typography variant="h4" fontWeight={600}>
//             Your Score: {result.totalScore} / {result.maxPossible}
//           </Typography>
//           <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
//             Thank you for completing the assessment.
//           </Typography>
//           <Button
//             variant="contained"
//             onClick={() => navigate("/ats/my-assessments")}
//             sx={{ mt: 3 }}
//           >
//             Back to My Assessments
//           </Button>
//         </Paper>
//       </Box>
//     );
//   }

//   return (
//     <Box>
//       <Typography variant="h4" fontWeight={600} gutterBottom>
//         {assignment?.Assessment?.title}
//       </Typography>
//       <Typography variant="body1" color="text.secondary" paragraph>
//         {assignment?.Assessment?.description}
//       </Typography>
//       <Divider sx={{ mb: 3 }} />

//       {questions.map((q, idx) => (
//         <Paper key={q.id} sx={{ p: 2, mb: 3 }}>
//           <Typography variant="h6" gutterBottom>
//             Q{idx + 1}: {q.question_text}
//           </Typography>
//           <FormControl component="fieldset">
//             <RadioGroup
//               value={answers[q.id]?.toString() || ""}
//               onChange={(e) => handleAnswerChange(q.id, e.target.value)}
//             >
//               {q.options.map((opt, optIdx) => (
//                 <FormControlLabel
//                   key={optIdx}
//                   value={optIdx.toString()}
//                   control={<Radio />}
//                   label={opt}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </Paper>
//       ))}

//       <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
//         <Button
//           variant="contained"
//           onClick={handleSubmit}
//           disabled={submitting || questions.length === 0}
//           sx={{ bgcolor: "#1a2a3a" }}
//         >
//           {submitting ? <CircularProgress size={24} /> : "Submit Assessment"}
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default TakeAssessment;
// pages/assessment/TakeAssessment.jsx
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  CircularProgress,
  Alert,
  Divider,
  LinearProgress,
  Stepper,
  Step,
  StepLabel,
  MobileStepper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useATS } from "../atsModule/context/ATSContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// Blue palette
const BLUE = {
  50: "#eff6ff",
  100: "#dbeafe",
  200: "#bfdbfe",
  300: "#93c5fd",
  400: "#60a5fa",
  500: "#3b82f6",
  600: "#2563eb",
  700: "#1d4ed8",
  900: "#1e3a8a",
};

// Keyframes
const KF_ID = "fa-keyframes-take";
if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
  const style = document.createElement("style");
  style.id = KF_ID;
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    @keyframes fadeUp { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
    @keyframes fadeIn  { from{opacity:0} to{opacity:1} }
    @keyframes scalePop { 0%{transform:scale(0.95)} 100%{transform:scale(1)} }
  `;
  document.head.appendChild(style);
}

const fontFam = "'Plus Jakarta Sans', sans-serif";

const primaryBtnSx = {
  background: `linear-gradient(135deg, ${BLUE[600]} 0%, ${BLUE[700]} 100%)`,
  color: "#fff",
  borderRadius: "12px",
  px: 3,
  py: 1.2,
  fontFamily: fontFam,
  fontWeight: 600,
  fontSize: "0.9rem",
  boxShadow: `0 4px 14px ${BLUE[200]}`,
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: `0 8px 22px ${BLUE[300]}`,
    background: `linear-gradient(135deg, ${BLUE[700]} 0%, ${BLUE[900]} 100%)`,
  },
  transition: "all 0.2s ease",
};

const TakeAssessment = () => {
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { store_id, user_id } = useATS();

  const [assignment, setAssignment] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [result, setResult] = useState(null);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (store_id === undefined || store_id === null) return;
      try {
        setLoading(true);
        const assignmentRes = await axios.get(
          `${API_BASE}/api/assessment/user-assessments/${assignmentId}`,
        );
        const assignData = assignmentRes.data.data;
        setAssignment(assignData);
        const questionsRes = await axios.get(
          `${API_BASE}/api/assessment/assessment-questions/assessment/${assignData.assessment_id}`,
        );
        setQuestions(questionsRes.data.data || []);
        setError("");
      } catch (err) {
        console.error(err);
        setError("Failed to load assessment");
      } finally {
        setLoading(false);
      }
    };
    if (assignmentId) fetchData();
  }, [assignmentId, store_id]);

  const handleAnswerChange = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: parseInt(value) });
  };

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleSubmit = async () => {
    const answeredCount = Object.keys(answers).length;
    if (questions.length > 0 && answeredCount !== questions.length) {
      alert(`Please answer all ${questions.length} questions.`);
      return;
    }
    const answersArray = Object.entries(answers).map(
      ([questionId, selected_option]) => ({
        question_id: parseInt(questionId),
        selected_option,
      }),
    );
    setSubmitting(true);
    try {
      const res = await axios.post(
        `${API_BASE}/api/assessment/user-assessments/${assignmentId}/submit-mcq`,
        {
          store_id,
          user_id,
          answers: answersArray,
          remarks: "",
        },
      );
      setResult(res.data.data);
      setSubmitted(true);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.statusMessage || "Submission failed");
    } finally {
      setSubmitting(false);
    }
  };

  const answeredCount = Object.keys(answers).length;
  const progress = questions.length
    ? (answeredCount / questions.length) * 100
    : 0;

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <CircularProgress sx={{ color: BLUE[600] }} />
      </Box>
    );
  }
  if (error)
    return (
      <Alert severity="error" sx={{ m: 3 }}>
        {error}
      </Alert>
    );

  // Result screen
  if (submitted && result) {
    const percentage = (result.totalScore / result.maxPossible) * 100;
    const passed = percentage >= 50; // assuming passing is 50%, but you can adjust
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 3,
          background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
          borderRadius: "24px",
          fontFamily: fontFam,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 5 },
            maxWidth: 550,
            width: "100%",
            textAlign: "center",
            borderRadius: "32px",
            background: "#fff",
            boxShadow: "0 20px 40px -12px rgba(0,0,0,0.15)",
            animation: "scalePop 0.4s ease",
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: passed ? "#e8f5e9" : "#ffebee",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
            }}
          >
            <CheckCircleOutlineIcon
              sx={{ fontSize: 48, color: passed ? "#2e7d32" : "#d32f2f" }}
            />
          </Box>
          <Typography
            variant="h4"
            fontWeight={800}
            sx={{ color: "#0f172a", mb: 1 }}
          >
            Assessment Submitted!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {passed
              ? "Great job! You've passed."
              : "Keep learning and try again."}
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Typography variant="h2" fontWeight={800} sx={{ color: BLUE[600] }}>
            {result.totalScore}
            <Typography component="span" variant="h6" sx={{ color: "#94a3b8" }}>
              /{result.maxPossible}
            </Typography>
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Your total score
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/ats/my-assessments")}
            sx={{ mt: 4, ...primaryBtnSx }}
          >
            Back to My Assessments
          </Button>
        </Paper>
      </Box>
    );
  }

  const currentQuestion = questions[activeStep];
  const isLastStep = activeStep === questions.length - 1;

  // Mobile stepper (dots)
  const mobileStepper = (
    <MobileStepper
      variant="dots"
      steps={questions.length}
      position="static"
      activeStep={activeStep}
      nextButton={
        <Button size="small" onClick={handleNext} disabled={isLastStep}>
          Next <KeyboardArrowRight />
        </Button>
      }
      backButton={
        <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
          <KeyboardArrowLeft /> Back
        </Button>
      }
      sx={{ background: "transparent", mb: 2 }}
    />
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: fontFam,
        p: { xs: 2, sm: 4 },
      }}
    >
      {/* Header */}
      <Box sx={{ maxWidth: 800, mx: "auto", mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            color: "#0f172a",
            mb: 1,
            letterSpacing: "-0.5px",
          }}
        >
          {assignment?.Assessment?.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          {assignment?.Assessment?.description}
        </Typography>
        {/* Progress bar */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
          <Box sx={{ flex: 1 }}>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: 8,
                borderRadius: 4,
                backgroundColor: "#e2e8f0",
                "& .MuiLinearProgress-bar": {
                  borderRadius: 4,
                  background: `linear-gradient(90deg, ${BLUE[400]}, ${BLUE[600]})`,
                },
              }}
            />
          </Box>
          <Typography variant="body2" fontWeight={500}>
            {answeredCount}/{questions.length}
          </Typography>
        </Box>
      </Box>

      {/* Question area */}
      {questions.length > 0 && (
        <Box sx={{ maxWidth: 800, mx: "auto" }}>
          {/* Desktop Stepper (optional) – use horizontal steps for clarity */}
          {!isMobile && (
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              sx={{ mb: 4, px: 2 }}
            >
              {questions.map((_, idx) => (
                <Step key={idx}>
                  <StepLabel
                    StepIconProps={{
                      sx: {
                        "&.Mui-active": { color: BLUE[600] },
                        "&.Mui-completed": { color: BLUE[400] },
                      },
                    }}
                  >
                    <Typography variant="caption" sx={{ fontFamily: fontFam }}>
                      Q{idx + 1}
                    </Typography>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          )}

          {isMobile && mobileStepper}

          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, sm: 4 },
              borderRadius: "24px",
              background: "#fff",
              boxShadow: "0 8px 30px rgba(0,0,0,0.05)",
              animation: "fadeUp 0.4s ease",
              border: "1px solid #f1f5f9",
            }}
          >
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#0f172a",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "12px",
                    background: BLUE[100],
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: BLUE[700],
                    fontWeight: 800,
                  }}
                >
                  {activeStep + 1}
                </Box>
                {currentQuestion.question_text}
              </Typography>
            </Box>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                value={answers[currentQuestion.id]?.toString() || ""}
                onChange={(e) =>
                  handleAnswerChange(currentQuestion.id, e.target.value)
                }
              >
                {currentQuestion.options.map((opt, optIdx) => (
                  <Paper
                    key={optIdx}
                    elevation={0}
                    sx={{
                      mb: 1.5,
                      border:
                        answers[currentQuestion.id] === optIdx
                          ? `2px solid ${BLUE[400]}`
                          : "1px solid #e2e8f0",
                      borderRadius: "16px",
                      transition: "all 0.2s",
                      "&:hover": {
                        borderColor: BLUE[300],
                        backgroundColor: BLUE[50],
                      },
                    }}
                  >
                    <FormControlLabel
                      value={optIdx.toString()}
                      control={
                        <Radio
                          sx={{
                            color: BLUE[400],
                            "&.Mui-checked": { color: BLUE[600] },
                          }}
                        />
                      }
                      label={
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 500, py: 1 }}
                        >
                          {opt}
                        </Typography>
                      }
                      sx={{ width: "100%", mx: 0, px: 2 }}
                    />
                  </Paper>
                ))}
              </RadioGroup>
            </FormControl>
          </Paper>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <Button
              variant="outlined"
              onClick={handleBack}
              disabled={activeStep === 0}
              sx={{
                borderRadius: "12px",
                borderColor: "#cbd5e1",
                color: "#475569",
                fontFamily: fontFam,
                "&:hover": {
                  borderColor: BLUE[500],
                  backgroundColor: BLUE[50],
                },
              }}
            >
              <KeyboardArrowLeft /> Back
            </Button>
            {!isLastStep ? (
              <Button
                variant="contained"
                onClick={handleNext}
                sx={primaryBtnSx}
              >
                Next <KeyboardArrowRight />
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={submitting}
                sx={primaryBtnSx}
                startIcon={
                  submitting ? (
                    <CircularProgress size={20} />
                  ) : (
                    <AutoAwesomeIcon />
                  )
                }
              >
                {submitting ? "Submitting..." : "Submit Assessment"}
              </Button>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default TakeAssessment;
